import React from 'react'
import PropTypes from 'prop-types'
import { RichText } from 'prismic-reactjs'
import Container from '@material-ui/core/Container'
import Typography from '@material-ui/core/Typography'

// Components
import SEO from '../../components/seo'
import PageBreadcrumbs from '../../components/breadcrumbs/pageBreadcrumbs'

const RefundPolicyPage = (props) => {
  // console.log('👾 RefundPolicyPage > ', props)
	const { title, content } = props.data.prismicPage.data
  
  return (
    <>
			<SEO title={title} />
			<PageBreadcrumbs pageTitle={title} />
      <Container maxWidth="lg">
				<Typography variant="h2" component="h1">{title}</Typography>
				<RichText render={content.raw} />
			</Container>
    </>
  )
}

export default RefundPolicyPage

RefundPolicyPage.propTypes = {}
RefundPolicyPage.defaultProps = {}
